<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit' }">Audit</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Audit refunds'}">
          {{ $root.getHeader() }} Audit report for Refund Requests
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <el-table :data="refundRequests" v-loading="loading">
      <el-table-column label="Process At" prop="processAt" :width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.completed ? 'success' : 'info'">
            {{ scope.row.processAt | formatDate }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Created At" :width="100">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover">
            <template slot="default">
              ID: {{ scope.row.id }}
            </template>
            <el-tag slot="reference">
              {{ scope.row.createdAt | formatDate }}
            </el-tag>
            <!-- <el-button slot="reference">Hover to activate</el-button> -->
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        label="Amount"
        prop="amount"
        :width="150"
        :formatter="(row, column, cellValue ) => $options.filters.currencySign(cellValue, this.$root.state.facilityData)"
      >
      </el-table-column>
      <el-table-column label="Created By" prop="createdBy" :width="150"></el-table-column>
      <el-table-column label="Code" prop="facility.code"></el-table-column>
      <el-table-column label="Member" prop="customer.company" :width="150">
        <template slot-scope="scope">
          <el-button type="text" @click="() => routeToCustomer(scope.row)">{{ scope.row.customer.company }}</el-button>
        </template>
      </el-table-column>
      <el-table-column label="Description" prop="detail" :width="350"></el-table-column>
      <el-table-column label="Reason" prop="reason" :width="350"></el-table-column>
      <el-table-column label="Actions" fixed="right" :width="250">
        <template slot-scope="scope">
          <div v-if="scope.row.completed">
            Completed
            <i
              class="el-icon-success"
              :style="{ color: 'green' }"
            >
            </i>
          </div>
          <div v-else-if="scope.row.cancelled">
            Cancelled By: {{  scope.row.cancelledBy }}
          </div>
          <div v-else-if="scope.row.approved">
            Approved By: {{  scope.row.approvedBy }}
          </div>
          <el-button
            v-if="!scope.row.cancelled && !scope.row.completed"
            size="mini"
            type="danger"
            @click="() => handleCancel(scope.row)">Cancel</el-button>
            <!-- v-if="!scope.row.approved && !scope.row.cancelled" -->
            <el-button
            v-if="!scope.row.cancelled && !scope.row.approved"
            size="mini"
            type="success"
            @click="() => openDialog(scope.row)">Approve</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <el-pagination
      hide-on-single-page
      background
      :total="totalCount"
      layout="prev, pager, next"
      @current-change="handlePages"
    >
    </el-pagination>
    <el-dialog :visible.sync="previewInvoiceDialog" width="55%">
      <RefundRequestInvoice v-if="selectedRefundRequest" :request="selectedRefundRequest" @uploaded="handleApprove"/>
    </el-dialog>
  </el-card>
</template>

<script>
import axios from 'axios';
import RefundRequestInvoice from './RefundRequestInvoice.vue';
import { REFUND_REQUEST_API_BASE } from '../env';

export default {
  name: 'AuditRefundRequests',
  components: { RefundRequestInvoice },
  props: {
    facility: { type: String, required: true },
  },
  watch: {
    async facility() {
      this.loading = true;
      await this.getRefundRequests();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    await this.getRefundRequests();
    this.loading = false;
  },
  data() {
    return {
      refundRequests: [],
      selectedRefundRequest: null,
      previewInvoiceDialog: false,
      loading: false,
      totalCount: 0,
      currentPage: 0,
    };
  },
  methods: {
    async handlePages(newPage) {
      this.currentPage = newPage;
      await this.getRefundRequests();
    },
    async openDialog(request) {
      console.log( request);
      // await this.handleApprove(request);
      request.approvedBy = this.$keycloak.tokenParsed.name;
      request.approvedAt = new Date();
      this.selectedRefundRequest = request;
      this.previewInvoiceDialog = true;
    },
    async getRefundRequests() {
      this.loading = true;
      const response = await axios.get(`${REFUND_REQUEST_API_BASE}/v1/requests/${this.facility}`, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
        params: {
          ...(this.currentPage ? { pageNumber: this.currentPage } : {}),
        },
      });

      this.loading = false;
      this.refundRequests = response.data.data;
      this.totalCount = response.data.pagination.totalCount;
      this.currentPage = response.data.pagination.pageNo;
    },
    async handleCancel(refundRequest) {
      this.loading = true;
      await axios.post(`${REFUND_REQUEST_API_BASE}/v1/requests/${this.facility}/${refundRequest._id}/cancel`, {
        cancelledBy: this.$keycloak.tokenParsed.name,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.loading = false;
      this.selectedRefundRequest = null;
      await this.getRefundRequests();
    },
    async handleApprove(url) {
      this.previewInvoiceDialog = false;
      this.loading = true;
      await axios.post(`${REFUND_REQUEST_API_BASE}/v1/requests/${this.facility}/${this.selectedRefundRequest._id}/approve`, {
        approvedBy: this.$keycloak.tokenParsed.name,
        attachment: url,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.loading = false;
      this.selectedRefundRequest = null;
      await this.getRefundRequests();
    },
    routeToCustomer(row) {
      this.$router.push({ name: 'Facility Customer', params: { id: row.customer._id, facility: row.facility._id } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/AuditRefundRequests.vue